import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {
    index: async (handleRedirect = null) => {
        const url = apiConfig.apiUrl + "referrals/";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    generateReferralLink: async (handleRedirect = null) => {
        const url = apiConfig.apiUrl + "referrals/generate_referral_link";

        const body = JSON.stringify({
            referral_link: {
            }
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                body: body,
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    removeReferralsHighlight: async (handleRedirect = null) => {
        const url = apiConfig.apiUrl + "referrals/remove_referrals_highlight";

        const body = JSON.stringify({
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                credentials: 'include',
                body: body,
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    generateMissionReferralLink: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "referrals/generate_mission_referral_link";

        const body = JSON.stringify({
            mission_id: missionId
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                body: body,
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    }

}